import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom"; 
import * as api from "../../../actions/api";
import LocationFormData from "./LocationFormData";
import encryptionService from "../../../services/encryptionService";



const EditLocation = (props) => {

    //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "location-entry";
  const UserInfo = encryptionService.decryptUserInfo();  
  const UserName = UserInfo==0?'': UserInfo[0].name;

  const [formData, setFormData] = useState({
    LocationName: "",
    ContactName: "",
    ContactNo: "",
    Email: "",
    LocationsAddress: "",
  });

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  useQuery(
    ["location", id],
    () =>
      api.getLocations(id).then((res) => {
        setFormData(res.data);
        return res.data;
      }),
    {
      enabled: Boolean(id),
    }
  );

  const { mutate } = useMutation(api.UpdateLocations, {
    onSuccess: (data) => { 
      if (data.status == 200) {
        api.getAllDropdown('FacilityLocation').then((response) => {
          localStorage.setItem(
            "FacilityLocation",
            JSON.stringify(response.datalist.FacilityLocation)
          );
        })

        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });

        queryClient.getQueriesData("location"); // include the page name
        props.history.push("/location-entry"); //page url
      }else{

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;

    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      LocationName: "",
      ContactName: "",
      ContactNo: "",
      Email: "",
      LocationsAddress: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["LocationName","ContactNo"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleUpdate = async (e) => {
    if (validateForm(formData)) {
      let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName}; 
      mutate(fDtat);
     
       
    }
  };

  return (
    <>
      <LocationFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        {...props}
      />
    </>
  );
};

export default EditLocation;
